import clsx from "clsx";
import { forwardRef, InputHTMLAttributes } from "react";
import { Input } from "../input/index";

export type InputProps = Omit<
  InputHTMLAttributes<HTMLInputElement>,
  "onChange" | "type"
> & {
  wholeNumbers?: boolean;
  min: number;
  max: number;
  onChange?: (value: string) => void;
};

export const NumberInput = forwardRef<HTMLInputElement, InputProps>(
  (
    { wholeNumbers = false, min, max, className, onChange, value, ...props },
    ref,
  ) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      let targetValue = e.target.value;

      targetValue = targetValue.replace(/-/g, "");

      if (!wholeNumbers) {
        targetValue = targetValue.replace(/[^0-9.]/g, "");
      } else {
        targetValue = targetValue.replace(/[^0-9]/g, "");
      }

      return onChange?.(targetValue);
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (e.key === "-" || e.key === "e" || (wholeNumbers && e.key === ".")) {
        e.preventDefault();
      }
    };

    return (
      <Input
        ref={ref}
        type="number"
        min={min}
        max={max}
        className={clsx(className)}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        value={value}
        {...props}
      />
    );
  },
);

NumberInput.displayName = "NumberInput";
